export enum NoticeMessage {
  ADDED_SUCCESS = 'New user has been successfully added!',
  ADDED_ERROR = 'New user has not been added! Try again!',
  UPDATED_SUCCESS = 'User data has been successfully changed!',
  UPDATED_ERROR = 'User has not been changed! Try again!',
  DELETED_SUCCESS = 'User has been successfully deleted!',
  DELETED_ERROR = 'User has not been deleted! Try again!',
}
